import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

export const DisplayContext = createContext();

const getViewportSize = () => {
  if (window.visualViewport) {
    return { width: window.visualViewport.width, height: window.visualViewport.height };
  }
  return { width: window.innerWidth, height: window.innerHeight };
};

export const DisplayProvider = ({ children }) => {
  const getIsMobile = () => window.innerWidth < 768;
  const getIsTablet = () => window.innerWidth >= 768 && window.innerWidth < 1024;
  const getIsSmallHeight = () => getViewportSize().height < 500;

  const [isMobile, setIsMobile] = useState(getIsMobile());
  const [isTablet, setIsTablet] = useState(getIsTablet());
  const [isSmallHeight, setIsSmallHeight] = useState(getIsSmallHeight());
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const [showSidebar, setShowSidebar] = useState(!getIsMobile());

  const handleResize = useCallback(() => {
    const mobile = getIsMobile();
    const tablet = getIsTablet();
    const smallHeight = getIsSmallHeight();
    const { width: vw, height: vh } = getViewportSize();

    setIsMobile(mobile);
    setIsTablet(tablet);
    setIsSmallHeight(smallHeight);
    setViewportWidth(vw);
    setViewportHeight(vh);
    if (mobile) setShowSidebar(false);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    window.visualViewport?.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  const toggleSidebar = () => setShowSidebar((prev) => !prev);

  return (
    <DisplayContext.Provider value={{
      showSidebar, setShowSidebar, toggleSidebar,
      isMobile, isTablet, isSmallHeight,
      viewportWidth, viewportHeight
    }}>
      {children}
    </DisplayContext.Provider>
  );
};

export const useDisplay = () => useContext(DisplayContext);
